import { useAuthApi, UserRoles } from '../../../..';

export type AuthAccountResponseType = {
  [x: string]: string;
  id: string,
  userRole: UserRoles,
  firstName: string,
  surname: string,
  email: string,
  companyTradingName: string,
  brokerUserId: string,
  companyId: string,
}

export function useAuthAccountApi() {
  const { post } = useAuthApi();

  return {
    login: (userName?: string, password?: string): Promise<AuthAccountResponseType> => post('user/login-user', {
      ...((userName && password) && { 'emailAddress': userName, password, token: null }),
    }),
    refresh: (): Promise<AuthAccountResponseType> => post('user/refresh-token', {}),
    logout: (): Promise<boolean> => post('user/logout-user', {}),
    validate: (): Promise<boolean> => post('user/validate-token', {}).then((response) => response.isValid),
  };
}
